import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { backupDb } from 'src/services/db';

const useBackupDb = (onSuccess: () => void) => {
  const { isLoading, mutateAsync, isError } = useMutation(() => backupDb());

  const backupDbMutation = async () => {
    try {
      const response = await mutateAsync();
      //@ts-ignore
      if (response.success) {
        onSuccess();
      }
    } catch (error: any) {
      console.error(error);
      toast.error(error.message || 'An error occurred');
    }
  };

  return { isLoading, backupDbMutation, isError };
};

export default useBackupDb;
